import PriceSummary from './components/PriceSummary/PriceSummary';
export {
    default as edapTriggerPriceSummaryDisplay
} from './util/edapTriggerPriceSummaryDisplay';

export default PriceSummary;
